export const addWatermarkToImage = async (
  file: File,
  watermarkText: string
): Promise<File> => {
  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    const img = new Image();

    reader.onload = (e) => {
      if (!e.target?.result) {
        reject(new Error("Failed to read file"));
        return;
      }

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        if (!ctx) {
          reject(new Error("Failed to get canvas context"));
          return;
        }

        canvas.width = img.width;
        canvas.height = img.height;

        ctx.drawImage(img, 0, 0);

        const fontSize = Math.floor(img.width * 0.04);
        ctx.font = `${fontSize}px Arial`;

        // Вимірюємо розмір тексту
        const textMetrics = ctx.measureText(watermarkText);
        const textWidth = textMetrics.width;
        const textHeight = fontSize;

        // Додаємо відступи для фону
        const padding = fontSize * 0.25;
        const bgWidth = textWidth + padding * 2;
        const bgHeight = textHeight + padding * 2;

        // Малюємо напівпрозорий чорний фон
        ctx.fillStyle = "rgba(0, 0, 0, 0.3)";
        ctx.fillRect(
          canvas.width * 0.02 - padding,
          canvas.height - canvas.height * 0.015 - textHeight - padding,
          bgWidth,
          bgHeight
        );

        // Малюємо текст
        ctx.fillStyle = "rgba(255, 255, 255, 0.9)";
        ctx.textAlign = "left";
        ctx.textBaseline = "bottom";

        ctx.fillText(
          watermarkText,
          canvas.width * 0.02,
          canvas.height - canvas.height * 0.015
        );

        canvas.toBlob((blob) => {
          if (!blob) {
            reject(new Error("Failed to create blob"));
            return;
          }

          const watermarkedFile = new File([blob], file.name, {
            type: file.type
          });

          resolve(watermarkedFile);
        }, file.type);
      };

      img.onerror = () => reject(new Error("Failed to load image"));
      img.src = e.target.result as string;
    };

    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
};
